import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { nextTick, ref, watch } from 'vue'

import {
  TripCancellationRequest,
  TripFull,
  TripCancellationRequestStatus,
} from '@/models/trip'

import { normalizeFalsy } from '@/helpers/strings'
import { normalizeUserName } from '@/helpers/user'

interface Props {
  trip: TripFull
  request: TripCancellationRequest
  isCommentUpdating: boolean
  isSuccessCommentUpdating: boolean
  isResolving: boolean
  editable: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CancellationRequestItem',
  props: {
    trip: {},
    request: {},
    isCommentUpdating: { type: Boolean },
    isSuccessCommentUpdating: { type: Boolean },
    isResolving: { type: Boolean },
    editable: { type: Boolean, default: true }
  },
  emits: ["updateComment", "resolveRequest"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const inputRef = ref<HTMLInputElement | null>(null)

const isEditingMode = ref(false)
const comment = ref(props.request.admin_comment || '')

watch(
  () => props.isSuccessCommentUpdating,
  (newValue, prevValue) => {
    if (!prevValue && newValue) isEditingMode.value = false
  }
)

const handleCommentUpdateClick = () => {
  emit('updateComment', props.trip.id, props.request.id, comment.value)
}

const handleResolveConfirm = () => {
  if (isEditingMode.value) isEditingMode.value = false

  emit('resolveRequest', props.trip.id, props.request.id)
}

const handleEditClick = async () => {
  isEditingMode.value = true
  await nextTick()
  inputRef.value?.focus()
}

const handleCancelClick = () => {
  isEditingMode.value = false
  comment.value = props.request.admin_comment || ''
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!

  return (_openBlock(), _createBlock(_component_el_descriptions, {
    border: "",
    column: 2,
    title: `Cancellation request: ${_ctx.request.id}`,
    direction: "vertical",
    class: "description-container"
  }, {
    extra: _withCtx(() => [
      (_ctx.request.status === _unref(TripCancellationRequestStatus).OPENED)
        ? (_openBlock(), _createBlock(_component_el_popconfirm, {
            key: 0,
            title: "Are you sure you want to resolve the request?",
            confirmButtonText: "Resolve",
            cancelButtonText: "Cancel",
            onConfirm: handleResolveConfirm
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                plain: "",
                loading: _ctx.isResolving,
                disabled: _ctx.isCommentUpdating || !_ctx.editable
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode(" Resolve ")
                ])),
                _: 1,
                __: [1]
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_descriptions_item, { width: 270 }, {
        label: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Status")
        ])),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.request.status), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("Reason")
        ])),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.request.reason), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.trip.host_id === _ctx.request.user_id ? 'Host' : 'Renter'), 1)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_unref(normalizeUserName)(
          _ctx.trip.host_id === _ctx.request.user_id ? _ctx.trip.host : _ctx.trip.renter
        )), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, {
        "class-name": "comment-container",
        "label-class-name": "comment-label-container"
      }, {
        label: _withCtx(() => [
          _cache[6] || (_cache[6] = _createElementVNode("div", null, "Admin comment", -1)),
          (!isEditingMode.value)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                plain: "",
                size: "small",
                icon: "el-icon-edit",
                disabled: _ctx.isResolving || !_ctx.editable,
                onClick: handleEditClick
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Edit ")
                ])),
                _: 1,
                __: [4]
              }, 8, ["disabled"]))
            : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                plain: "",
                size: "small",
                type: "danger",
                icon: "el-icon-edit",
                disabled: _ctx.isCommentUpdating || _ctx.isResolving,
                onClick: handleCancelClick
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" Cancel ")
                ])),
                _: 1,
                __: [5]
              }, 8, ["disabled"]))
        ]),
        default: _withCtx(() => [
          (isEditingMode.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_input, {
                  ref_key: "inputRef",
                  ref: inputRef,
                  type: "textarea",
                  autosize: { minRows: 2, maxRows: 4 },
                  placeholder: "Enter the comment",
                  resize: "vertical",
                  modelValue: comment.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((comment).value = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  size: "medium",
                  type: "primary",
                  plain: "",
                  loading: _ctx.isCommentUpdating,
                  disabled: !comment.value || _ctx.isResolving,
                  onClick: handleCommentUpdateClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.request.admin_comment ? 'Update comment' : 'Save comment'), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_unref(normalizeFalsy)(_ctx.request.admin_comment)), 1)
              ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})